import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const TextWithIconsOnRight = ({ doc }) => {
  const {
    internal_link_id,
    header,
    description,
    link: { url, target },
    link_text,
    bg_color,
    icon_alignment,
  } = doc?.primary || {};
  const style = { backgroundColor: bg_color };
  const alignClass =
    icon_alignment === "horizontal"
      ? "d-flex flex-wrap align-items-center text-with-icons-horizontal-content"
      : "text-with-icons-vertical-content";
  return (
    <div className="py-5 py-2xl-5 text-with-icons-right-slice prismic-slice" style={style}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-absolute d-block" />
      )}
      <div className="container container-width">
        <div className={`text-with-icons-content-section ${alignClass}`}>
          <div className="text-with-icon-content-block block-left">
            {checkContentPresence(header) && (
              <div className="sns-h2 text-with-icon-right-title same-size-title">
                {textResolver(header)}
              </div>
            )}
            {checkContentPresence(description) && (
              <div className="mt-4 mt-2xl-4 sns-h4 text-with-icon-right-description">
                {textResolver(description)}
              </div>
            )}
            {url && checkContentPresence(link_text) && (
              <div className="mt-4 mt-2xl-4 text-with-icon-right-block-link-row">
                <PrismicLinkTag
                  urlText={link_text}
                  url={url}
                  target={target}
                  className="text-uppercase font-weight-bold program-link text-with-icon-right-block-link"
                />
              </div>
            )}
          </div>
          <div className="text-with-icon-content-block block-right">
            {!!doc?.items?.length && (
              <div className="d-flex flex-wrap text-with-icon-assets-content-row">
                {doc?.items?.map(
                  (
                    { image: { url: imageUrl, alt: imageAlt }, image_title, image_description },
                    index
                  ) => (
                    <div
                      className="mb-4 mb-2xl-4 pr-md-3 pr-2xl-3 d-flex align-items-center text-with-icon-right-assets-content-block"
                      key={index}
                    >
                      {imageUrl && (
                        <div className="text-with-icon-right-image-holder">
                          <PrismicImgix
                            className="img-responsive img-responsive-height"
                            src={imageUrl}
                            alt={imageAlt}
                            desktop="40px"
                            mobile="30px"
                            tablet="40px"
                            largeDisplay="40px"
                          />
                        </div>
                      )}
                      <div className="text-with-icon-right-assets-text-holder">
                        {checkContentPresence(image_title) && (
                          <div className="font-weight-bold text-with-icon-right-assets-title">
                            {textResolver(image_title)}
                          </div>
                        )}
                        {checkContentPresence(image_description) && (
                          <div className="mt-2 mt-2xl-2 text-with-icon-right-assets-description">
                            {textResolver(image_description)}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextWithIconsOnRight;
